import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { SERVICE_PATHS } from './paths';

/** Сервис классической разработки: угловые скобки кода в контейнере. */
export const ServiceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {SERVICE_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
